module.exports = __webpack_public_path__ + "media/assets/images/flags/cy-088b64feeb856e116ee01ab2a3eb5a21.svg";